import "core-js/modules/es.array.concat.js";
import { colors as semanticColors } from "./semanticColors";
/**
 *  @internal Please don't use this unless you are storybook
 */
export var ICON_COLORS = [
// 'disabled',
'magic', 'negative', 'positive', 'primary', 'secondary', 'warning', 'white'];

/**
 *  @internal Please don't use this unless you are storybook
 */
export var INTENTS = ['magic', 'negative', 'positive', 'primary', 'secondary', 'warning'];

/**
 *  @internal Please don't use this unless you are storybook
 */
export var CONTRASTS = ['high', 'mid', 'low', 'inverted'];

/**
 *  @internal Please don't use this unless you are storybook
 */
export var ICON_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];

/**
 *  @internal Please don't use this unless you are storybook
 */
export var ICON_SHADES = ['dark', 'default', 'light'];

/**
 *  @internal Please don't use this unless you are storybook
 */
export var ICON_COLORS_SHADES = [].concat(ICON_COLORS, ['magic.dark', 'magic.default', 'magic.light', 'negative.dark', 'negative.default', 'negative.light', 'positive.dark', 'positive.default', 'positive.light', 'primary.dark', 'primary.default', 'primary.light', 'secondary.dark', 'secondary.default', 'secondary.light', 'warning.dark', 'warning.default', 'warning.light']);
// These are temporary until we change every icon to use `intent` instead of
// `color` / `legacyColor`.
//
// `intent` will access colors from the crystal-ui theme.  Once we migrate we
// can remove this object
export var iconography = {
  magic: {
    dark: '#5D197E',
    "default": '#9B47C7',
    light: '#F6E9FD'
  },
  negative: {
    dark: '#76132D',
    "default": '#D32252',
    light: '#FEE8EE'
  },
  positive: {
    dark: '#064439',
    "default": '#087C69',
    light: '#DFF3F0'
  },
  primary: {
    dark: '#00368A',
    "default": '#1E6DEB',
    light: '#E6EFFE'
  },
  secondary: {
    dark: '#363B51',
    "default": '#616D92',
    light: '#EAEEF7'
  },
  warning: {
    dark: '#612D10',
    "default": '#B35126',
    light: '#FFCC60'
  },
  white: '#ffffff'
};
export var getIconColor = function getIconColor(colorCode) {
  var shade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  switch (colorCode) {
    case 'magic':
    case 'negative':
    case 'positive':
    case 'primary':
    case 'secondary':
    case 'warning':
      return iconography[colorCode][shade];
    case 'white':
      return iconography.white;
    default:
      return 'currentColor';
  }
};
var intentColorMapping = {
  magic: {
    high: semanticColors.iconMagicHighContrast,
    low: semanticColors.iconMagicLowContrast,
    mid: semanticColors.iconMagic
  },
  negative: {
    high: semanticColors.iconNegativeHighContrast,
    low: semanticColors.iconNegativeLowContrast,
    mid: semanticColors.iconNegative
  },
  positive: {
    high: semanticColors.iconPositiveHighContrast,
    low: semanticColors.iconPositiveLowContrast,
    mid: semanticColors.iconPositive
  },
  primary: {
    high: semanticColors.iconPrimaryHighContrast,
    low: semanticColors.iconPrimaryLowContrast,
    mid: semanticColors.iconPrimary
  },
  secondary: {
    high: semanticColors.iconSecondaryHighContrast,
    low: semanticColors.iconSecondaryLowContrast,
    mid: semanticColors.iconSecondary
  },
  warning: {
    high: semanticColors.iconWarningHighContrast,
    low: semanticColors.iconWarningLowContrast,
    mid: semanticColors.iconWarning
  }
};
export var getIconIntent = function getIconIntent(intent, contrast) {
  if (!intent || contrast === 'inverted') {
    return semanticColors.iconInverted;
  }
  var adjustedContrast = contrast === 'stark' ? 'high' : contrast === 'regular' ? 'mid' : contrast;
  return intentColorMapping[intent][adjustedContrast];
};
export var getIconSize = function getIconSize() {
  var sizeCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'md';
  switch (sizeCode) {
    case 'xs':
      return '10px';
    case 'sm':
      return '16px';
    case 'md':
      return '24px';
    case 'lg':
      return '32px';
    case 'xl':
      return '48px';
    default:
      throw new Error("Size code not supported: ".concat(sizeCode));
  }
};
export var spacing = function spacing(num) {
  return num * 8;
};